<template>
  <main>
    <nav-bar></nav-bar>
    <header-section></header-section>
    <soap-section></soap-section>
    <drama-section></drama-section>
    <reality-section></reality-section>
    <sport-section></sport-section>
    <quiz-section></quiz-section>
  </main>
</template>

<script>
  import data from "@/assets/data/data.js";
  import { mapMutations } from "vuex";
  import NavBar from "@/components/NavBar";
  import HeaderSection from "@/components/HeaderSection";
  import SoapSection from "@/components/SoapSection";
  import RealitySection from "@/components/RealitySection";
  import DramaSection from "@/components/DramaSection";
  import QuizSection from "@/components/QuizSection";
  import SportSection from "@/components/SportSection";

  export default {
    name: "App",
    components: {
      NavBar,
      HeaderSection,
      SoapSection,
      DramaSection,
      RealitySection,
      QuizSection,
      SportSection,
    },
    methods: {
      ...mapMutations(["updateTweetData"]),
    },
    created() {
      const loadedData = data.programmeData;

      this.updateTweetData(loadedData);
    },
  };
</script>

<style lang="scss">
  @import "@/assets/styles.scss";

  body,
  html {
    overflow-x: hidden;
  }
  @import "@/assets/styles.scss";

  html,
  body {
    overflow-x: hidden;
  }
</style>
